import { apiThreadPool } from "@/cache/SpatioTemporalTileCache/ApiQueryThreadPool";
import type { LegendStyle } from "@/overlay/components/Legends/hooks/utils";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";

export type LegendProps = {
  parameter: string;
  style?: LegendStyle;
  transparent?: boolean;
};

/**
 * Returns the legend in SVG format
 * https://www.meteomatics.com/en/api/wms/getlegendgraphic-request/#getlegndgraphicrequest
 * @param parameter API parameter
 * @param style Legend style. The default style is a recommended colormap depending on the parameter.
 * @param transparent Transparent background, default is false.
 */
export function useLegend({ parameter, style, transparent = false }: LegendProps): UseQueryResult<string> {
  return useQuery(
    ["getLegend", parameter, style, transparent],
    () => {
      return apiThreadPool.getLegend({ parameter, style: style, transparent });
    },
    {
      staleTime: Number.POSITIVE_INFINITY,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
}
